import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-api-docs',
    templateUrl: './api-docs.component.html',
    styleUrl: './api-docs.component.scss',
    standalone: false
})
export class ApiDocsComponent implements OnInit {

	loading = true;
	access = false;
	no_plan = false;

	baseUrl: string = environment.external_api || 'https://stage-api.revealense.com/api/V1';
  
  activeSection: string = 'overview';
  private sections: string[] = [];

	constructor(private authService: AuthService) {}

	ngOnInit(): void {
		this.no_plan = false;

		if (this.authService.currentClientValue.plan) {
			this.access = this.authService.currentClientValue.plan.configuration.api_access;
			
			if (this.access) {
				this.sections = [
					'overview', 'auth', 'workflow', 'create', 'analyze', 'status', 'details', 
					'list', 'update', 'delete', 'delete-video', 'all-answers', 'single-answer', 
					'gen-report', 'list-reports', 'get-report', 'translate-report', 'delete-report', 
					'templates', 'languages', 'questions', 'full-workflow', 'errors'
				];
				this.loading = false;
			} else {
				this.loading = false;
			}
		} else {
			this.no_plan = true;
			this.loading = false;
		}
	}

	scrollToSection(sectionId: string, event: Event) {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      // Offset for Velzon's top header
      const y = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  @HostListener('window:scroll')
	onWindowScroll() {
		let currentSection = this.activeSection;
		for (const section of this.sections) {
			const element = document.getElementById(section);
			if (element && window.scrollY >= (element.offsetTop - 120)) {
				currentSection = section;
			}
		}
		this.activeSection = currentSection;
	}

  copyUrl(url: string, event: Event) {
    const btn = event.target as HTMLElement;
    const originalText = btn.innerText;
    
    navigator.clipboard.writeText(url).then(() => {
      btn.innerText = '✓ Copied!';
      btn.classList.add('copied');
      setTimeout(() => {
        btn.innerText = originalText;
        btn.classList.remove('copied');
      }, 2000);
    }).catch(() => {
      // Fallback
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      btn.innerText = '✓ Copied!';
      btn.classList.add('copied');
      setTimeout(() => {
        btn.innerText = originalText;
        btn.classList.remove('copied');
      }, 2000);
    });
  }
}
